import { defaultEmployeeFormValues, EmployeeFormValues } from "../common/EmployeeFormValues";
import { defaultHospitalIndemnityFormValues, HospitalIndemnityFormValues } from "./HospitalIndemnityFormValues";
import { Language } from "../enums/Language";
import { HospitalizationBenefits } from "../enums/HospitalizationBenefits";
import { SurgeryBenefits } from "../enums/SurgeryBenefits";
import { MedicalTests } from "../enums/MedicalTests";
import { OtherBenefitChoices } from "../enums/OtherBenefitChoices";
import { EmergencyCare } from "../enums/EmergencyCare";
import { PregnancyCare } from "../enums/PregnancyCare";
import { OutpatientBenefits } from "../enums/OutpatientBenefits";
import { SubstanceAbuse } from "../enums/SubstanceAbuse";
import { MentalDisorder } from "../enums/MentalDisorder";
import { TypeOfDelivery } from "../enums/TypeOfDelivery";
import { ConditionType } from "../enums/ConditionType";

export type HospitalIndemnityEmployeeFormValues = EmployeeFormValues & HospitalIndemnityFormValues & {
    textPermission: boolean,
    preferredLanguage: Language,
    otherLanguage: string,
    claimDates: [{
        startDate: string
    }],
    conditionType: ConditionType,
    dependents: string,
    conditionDetails: string,
    firstVisit: string,
    diagnosisDate: string,
    policeReport: string,
    timeOfInjury: string,
    locationOfInjury: string,
    hospitalization: HospitalizationBenefits[],
    surgeryBenefits: SurgeryBenefits[],
    medicalTests: MedicalTests[],
    otherBenefits: OtherBenefitChoices[],
    typeOfDelivery: TypeOfDelivery[],
    pregnancyCare: PregnancyCare[],
    emergencyCare: EmergencyCare[],
    outpatientBenefits: OutpatientBenefits[],
    substanceAbuse: SubstanceAbuse[],
    mentalDisorder: MentalDisorder[],
    workRelated: boolean,
    hipaaConsent: boolean,
    confidentialMessages: string,
    permissionContactName: string,
    relationshipType: string,
    otherRelationshipDescription: string,
    representativeAuthority: string,
    authorityDescription: string,
    authorityDocumentation: string,
    facilityName: string,
    facilityPhoneNumber: string,
}

export const defaultHospitalIndemnityEmployeeFormValues = {
    ...defaultEmployeeFormValues,
    ...defaultHospitalIndemnityFormValues,
    textPermission: false,
    preferredLanguage: Language.ENGLISH,
    otherLanguage: '',
    claimDates: [{
        startDate: ''
    }],
    conditionType: '',
    dependents: '',
    conditionDetails: '',
    firstVisit: '',
    diagnosisDate: '',
    policeReport: '',
    timeOfInjury: '',
    locationOfInjury: '',
    hospitalization: [],
    surgeryBenefits: [],
    medicalTests: [],
    otherBenefits: [],
    typeOfDelivery: [],
    pregnancyCare: [],
    emergencyCare: [],
    outpatientBenefits: [],
    substanceAbuse: [],
    mentalDisorder: [],
    workRelated: false,
    hipaaConsent: false,
    confidentialMessages: '',
    permissionContactName: '',
    relationshipType: '',
    otherRelationshipDescription: '',
    representativeAuthority: 'No',
    authorityDescription: '',
    authorityDocumentation: '',
    facilityName: '',
    facilityPhoneNumber: ''
}
